import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm!: FormGroup;
  isLoading = false;
  emailSent = false;
  errorMessage = '';
  countdown = 60;
  canResend = true;
  private countdownInterval: any;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.initForm();
  }

  ngOnDestroy(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  initForm(): void {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  onSubmit(): void {
    if (this.forgotPasswordForm.valid && this.canResend) {
      this.isLoading = true;
      this.errorMessage = '';

      this.authService.forgotPassword(this.forgotPasswordForm.value).subscribe({
        next: (response: any) => {
          this.isLoading = false;
          this.emailSent = true;
          this.startCountdown();

        },
        error: (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.errorMessage = `${error.error.message || error.error.detail}`;
        },
      });
    } else if (!this.canResend) {
      this.errorMessage = `Veuillez attendre ${this.countdown}s avant de renvoyer un email`;
    } else {
      // Marquer le champ comme touché pour afficher l'erreur
      this.forgotPasswordForm.get('email')?.markAsTouched();
    }
  }

  startCountdown(): void {
    this.canResend = false;
    this.countdown = 60;

    this.countdownInterval = setInterval(() => {
      this.countdown--;

      if (this.countdown <= 0) {
        this.canResend = true;
        clearInterval(this.countdownInterval);
      }
    }, 1000);
  }

  resendEmail(): void {
    if (this.canResend) {
      this.onSubmit();
    }
  }

  navigateToSignin(): void {
    this.router.navigate(['/auth/signin']);
  }

  navigateToSignup(): void {
    this.router.navigate(['/auth/signup']);
  }

  getFieldError(fieldName: string): string {
    const field = this.forgotPasswordForm.get(fieldName);

    if (field?.hasError('required')) {
      return 'Ce champ est requis';
    }
    if (field?.hasError('email')) {
      return 'Email invalide';
    }

    return '';
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.forgotPasswordForm.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched));
  }
}
